"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    }
  }, [_c("template", {
    slot: "context"
  }, [_c("div", {
    staticClass: "farm-list-management-page"
  }, [_c("h1", [_vm._v("Fotos reconhecidas")]), _vm._v(" "), _c("form", {
    on: {
      submit: function submit($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments);
      }
    }
  }, [_c("div", {
    staticClass: "form-column"
  }, [_c("upload-photo", {
    ref: "uploadPhoto",
    model: {
      value: _vm.form.photo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "photo", $$v);
      },
      expression: "form.photo"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "form-column"
  }, [_c("label", {
    attrs: {
      for: "cpf"
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c("div", {
    staticClass: "form-field"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.cpf,
      expression: "form.cpf"
    }],
    attrs: {
      id: "cpf",
      type: "text",
      placeholder: "000.000.000-00",
      required: ""
    },
    domProps: {
      value: _vm.form.cpf
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "cpf", $event.target.value);
      }, _vm.formatCPF]
    }
  }), _vm._v(" "), _c("button", {
    attrs: {
      type: "submit",
      disabled: _vm.isLoading
    }
  }, [!_vm.isLoading ? _c("p", [_vm._v("\n                Registrar Funcionário\n              ")]) : _vm._e(), _vm._v(" "), _vm.isLoading ? _c("div", {
    staticClass: "spinner"
  }) : _vm._e()])]), _vm._v(" "), _c("p", {
    staticClass: "helper-text",
    class: {
      error: _vm.errorMessage
    }
  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage || _vm.helperText) + "\n          ")])])]), _vm._v(" "), _c("VerifiedPhotosTable", {
    attrs: {
      data: _vm.data,
      loading: _vm.isLoading
    },
    on: {
      "remove-photo": _vm.removeVerifiedPhoto
    }
  }), _vm._v(" "), _c("b-pagination", {
    staticClass: "mt-4",
    attrs: {
      total: _vm.meta.total,
      current: _vm.meta.currentPage,
      "per-page": _vm.meta.perPage,
      "range-before": "2",
      "range-after": "2",
      size: "is-small",
      order: "is-centered"
    },
    on: {
      "update:current": function updateCurrent($event) {
        return _vm.$set(_vm.meta, "currentPage", $event);
      },
      change: _vm.handlePageChange
    }
  })], 1)])], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;